<template>
  <div>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <v-container>
          <div v-for="(schema, s) in schemas[type]" :key="s">
            <template v-if="s !== 'pembiayaan_diklat'">
              <div class="body-1 font-weight-medium my-4">
                {{ $titleCase(s.replace('_', ' ')) }}
              </div>
              <base-form-generator :schema="schema" v-model="form" />
            </template>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card
      v-if="+$getDeepObj(masters, `pembiayaan-paud.${form['k_pembiayaan_paud']}.is_sertifikat`) === 1"
      class="mx-auto mt-5"
      flat
    >
      <v-card-text class="px-7">
        <div class="mb-5 mt-3">
          <v-alert color="blue" text type="info" dense>
            <div class="black--text" style="font-size: 16px">
              <strong>Pemberitahuan!</strong> Data yang diinputkan dan diunggah dibawah ini adalah data
              <strong class="orange--text text--darken-1">Lembaga Kerjasama, bukan data LPD.</strong>
            </div>
          </v-alert>
        </div>
        <div class="body-1 font-weight-medium mb-4"> Kebutuhan Sertifikat Identitas Lembaga Kerjasama </div>
        <base-form-generator :schema="schemas[type]['pembiayaan_diklat']" v-model="form" />
        <v-row>
          <v-col class="pb-0" cols="12" md="6" sm="12">
            <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px; color: #bf360c !important">
              Unggah Logo Instansi <span class="red--text">*</span>
            </span>
            <template v-if="initValue && initValue.csr_logo_url">
              <div class="mt-1 mb-4">
                <v-btn color="secondary" depressed small :href="initValue.csr_logo_url" target="_blank">
                  <v-icon left>mdi-eye</v-icon> Preview
                </v-btn>
                <v-btn class="mx-2" color="primary" depressed small @click="onDelete('csr_logo')">
                  <v-icon left>mdi-pencil</v-icon> Ubah Berkas
                </v-btn>
              </div>
            </template>
            <template v-else>
              <validation-provider name="File Logo Instansi" rules="required" v-slot="{ errors }">
                <v-file-input
                  v-model="form.csr_logo_file"
                  :error-messages="errors"
                  label="File Logo Instansi (10 KB - 200 KB)"
                  append-icon="mdi-paperclip"
                  prepend-icon=""
                  accept="image/*"
                  hint=""
                  :rules="[
                    (value) =>
                      (value && value.size < roundDecimal(200 * 1000)) ||
                      'Berkas yang Anda upload melebihi kapasitas maksimum!',
                  ]"
                  persistent-hint
                  show-size
                  outlined
                  dense
                  single-line
                ></v-file-input>
              </validation-provider>
            </template>
          </v-col>
          <v-col class="pb-0" cols="12" md="6" sm="12">
            <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px; color: #bf360c !important">
              Unggah TTD Instansi <span class="red--text">*</span>
            </span>
            <template v-if="initValue && initValue.csr_ttd_url">
              <div class="mt-1 mb-4">
                <v-btn color="secondary" depressed small :href="initValue.csr_ttd_url" target="_blank">
                  <v-icon left>mdi-eye</v-icon> Preview
                </v-btn>
                <v-btn class="mx-2" color="primary" depressed small @click="onDelete('csr_ttd')">
                  <v-icon left>mdi-pencil</v-icon> Ubah Berkas
                </v-btn>
              </div>
            </template>
            <template v-else>
              <validation-provider name="File TTD Instansi" rules="required" v-slot="{ errors }">
                <v-file-input
                  v-model="form.csr_ttd_file"
                  :error-messages="errors"
                  label="File TDD Instansi (10 KB - 200 KB)"
                  append-icon="mdi-paperclip"
                  prepend-icon=""
                  accept="image/*"
                  hint=""
                  :rules="[
                    (value) =>
                      (value && value.size < roundDecimal(200 * 1000)) ||
                      'Berkas yang Anda upload melebihi kapasitas maksimum!',
                  ]"
                  persistent-hint
                  show-size
                  outlined
                  dense
                  single-line
                ></v-file-input>
              </validation-provider>
            </template>
          </v-col>
          <v-col class="py-0" cols="12" md="6" sm="12">
            <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px; color: #bf360c !important">
              Unggah Stempel Instansi <span class="red--text">*</span>
            </span>
            <template v-if="initValue && initValue.csr_stempel_url">
              <div class="mt-1 mb-4">
                <v-btn color="secondary" depressed small :href="initValue.csr_stempel_url" target="_blank">
                  <v-icon left>mdi-eye</v-icon> Preview
                </v-btn>
                <v-btn class="mx-2" color="primary" depressed small @click="onDelete('csr_stempel')">
                  <v-icon left>mdi-pencil</v-icon> Ubah Berkas
                </v-btn>
              </div>
            </template>
            <template v-else>
              <validation-provider name="File Stempel Instansi" rules="required" v-slot="{ errors }">
                <v-file-input
                  v-model="form.csr_stempel_file"
                  :error-messages="errors"
                  label="File Stempel Instansi (10 KB - 200 KB)"
                  append-icon="mdi-paperclip"
                  prepend-icon=""
                  accept="image/*"
                  hint=""
                  :rules="[
                    (value) =>
                      (value && value.size < roundDecimal(200 * 1000)) ||
                      'Berkas yang Anda upload melebihi kapasitas maksimum!',
                  ]"
                  persistent-hint
                  show-size
                  outlined
                  dense
                  single-line
                ></v-file-input>
              </validation-provider>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import { mapState } from 'vuex';
import { ValidationProvider } from 'vee-validate';
import { roundDecimal } from '@utils/format';
export default {
  components: { ValidationProvider, BaseFormGenerator },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    periodes: {
      type: Array,
      default: () => [],
    },
    mapels: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'diklat',
    },
    detail: {
      type: Object,
      default: () => {},
    },
    jenis: {
      type: String,
      default: 'daring',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      lpd: (state) => (state.data && state.data.paud_instansi) || {},
      instansi: (state) => (state.data && state.data.instansi) || {},
    }),

    mPeriode() {
      return this.$arrToObj(this.periodes, 'paud_periode_id');
    },

    mMapel() {
      return this.$arrToObj(this.periodes, 'paud_mapel_kelas_id');
    },

    kLpd() {
      return Number(this.lpd && this.lpd.k_lpd_paud);
    },

    filterPropinsi() {
      const M_PROPINSI = this.$mapForMaster(this.masters.m_propinsi || {}).filter(
        (key) => key.value === Number(this.instansi && this.instansi.k_propinsi)
      );

      let result = {};
      M_PROPINSI.forEach((item) => {
        result[item.value] = item.text;
      });

      return result;
    },

    filterKota() {
      const M_KOTA = this.$mapForMaster(this.masters.m_kota || {}).filter(
        (key) => key.value === Number(this.instansi && this.instansi.k_kota)
      );

      let result = {};
      M_KOTA.forEach((item) => {
        result[item.value] = item.text;
      });

      return result;
    },

    configs() {
      const M_PROPINSI = Number(this.kLpd) > 1 ? this.filterPropinsi : this.masters.m_propinsi || {};
      const M_KOTA = Number(this.kLpd) === 3 ? this.filterKota : this.masters.m_kota || {};
      const M_KECAMATAN = this.masters.m_kecamatan || {};
      const M_KELURAHAN = this.masters.m_kelurahan || {};
      return {
        kelas: {
          selector: ['k_propinsi', 'k_kota', 'k_kecamatan', 'k_kelurahan'],
          required: ['k_propinsi', 'k_kota', 'k_kecamatan', 'k_kelurahan'],
          label: ['Provinsi', 'Kota/Kabupaten', 'Kecamatan', 'Kelurahan'],
          options: [M_PROPINSI, M_KOTA, M_KECAMATAN, M_KELURAHAN],
          disabled: [true, true, false, false],
          grid: [{ cols: 6 }, { cols: 6 }, { cols: 6 }, { cols: 6 }],
          useSchema: true,
        },
        diklat: {
          selector: ['k_propinsi', 'k_kota'],
          required: ['k_propinsi', 'k_kota'],
          label: ['Provinsi', 'Kota/Kabupaten'],
          options: [M_PROPINSI, M_KOTA],
          grid: [{ cols: 6 }, { cols: 6 }],
        },
      };
    },

    schemas() {
      const mPengajar = [];
      const periodes = this.periodes || [];
      let periodeDiklat = periodes.filter(
        (s) =>
          Number(s.k_diklat_paud) === Number(this.form.k_diklat_paud) &&
          Number(s.k_jenjang_diklat_paud) === Number(this.form.k_jenjang_diklat_paud)
      );
      const jmlPpm = {
        1: {
          min: 3,
          max: 9,
        },
        2: {
          min: 4,
          max: 10,
        },
        3: {
          min: 5,
          max: 11,
        },
      };

      for (
        let i = jmlPpm[this.$getDeepObj(this, 'detail.k_jenjang_diklat_paud') || 1]['min'];
        i <= jmlPpm[this.$getDeepObj(this, 'detail.k_jenjang_diklat_paud') || 1]['max'];
        i++
      ) {
        mPengajar.push({ value: i, text: i });
      }

      let temp = {
        diklat: {
          keterangan_diklat: [
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Diklat',
              dense: true,
              hint: 'wajib diisi',
              placeholder: 'Isikan Nama Diklat',
              required: true,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              grid: { cols: 12, md: 12 },
              labelColor: 'secondary',
            },
            {
              type: 'VTextarea',
              name: 'deskripsi',
              label: 'Deskripsi',
              hint: '',
              placeholder: 'Isi Deskripsi',
              required: false,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'cascade',
              configs: this.configs.diklat,
              grid: { cols: 12 },
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'paud_periode_id',
              label: 'Tahapan Diklat',
              hint: '',
              placeholder: '',
              items: periodeDiklat,
              itemValue: 'paud_periode_id',
              itemText: 'nama',
              required: false,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
          ],
          pendaftaran_peserta: [
            {
              type: 'VTextField',
              name: 'tgl_daftar_mulai',
              label: 'Tanggal Mulai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              readonly: true,
              singleLine: true,
              min: '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VTextField',
              name: 'tgl_daftar_selesai',
              label: 'Tanggal Selesai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              readonly: true,
              singleLine: true,
              min: '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
          ],
          pelaksanaan_diklat: [
            {
              type: 'VDatePicker',
              name: 'tgl_mulai',
              label: 'Tanggal Mulai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              min: '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VDatePicker',
              name: 'tgl_selesai',
              label: 'Tanggal Selesai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              min: this.form.tgl_mulai || '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'k_pembiayaan_paud',
              label: 'Jenis Pembiayaan Diklat',
              hint: '',
              placeholder: '',
              items: Object.values((this.masters && this.masters['pembiayaan-paud']) || {}),
              itemValue: 'k_pembiayaan_paud',
              itemText: 'keterangan',
              required: true,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
          ],
          pembiayaan_diklat: [
            {
              type: 'VTextField',
              name: 'csr_instansi',
              label: 'Nama Instansi',
              dense: true,
              required: true,
              hint: '',
              placeholder: '',
              outlined: true,
              singleLine: true,
              grid: { cols: 12 },
              labelColor: 'secondary',
            },
            {
              type: 'VTextField',
              name: 'csr_nama',
              label: 'Nama Penandatangan',
              dense: true,
              required: true,
              hint: '',
              placeholder: '',
              outlined: true,
              singleLine: true,
              grid: { cols: 12, lg: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VTextField',
              name: 'csr_jabatan',
              label: 'Jabatan Penandatangan',
              dense: true,
              required: true,
              hint: '',
              placeholder: '',
              outlined: true,
              singleLine: true,
              grid: { cols: 12, lg: 6 },
              labelColor: 'secondary',
            },
          ],
        },
        kelas: {
          tambah_kelas: [
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Kelas',
              dense: true,
              hint: 'wajib diisi',
              placeholder: 'Isikan Nama Kelas',
              required: true,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              grid: { cols: 12, md: 12 },
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'paud_mapel_kelas_id',
              label: 'Mata Pelajaran',
              hint: 'wajib dipilih',
              items: this.mapels,
              itemValue: 'paud_mapel_kelas_id',
              itemText: 'nama',
              required: true,
              hideDetails: false,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'jml_pengajar',
              label: 'Jumlah Pengajar',
              hint: 'wajib dipilih',
              required: true,
              hideDetails: false,
              outlined: true,
              dense: true,
              singleLine: true,
              items: mPengajar,
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VTextarea',
              name: 'deskripsi',
              label: 'Deskripsi',
              hint: '',
              placeholder: 'Isi Deskripsi Kelas',
              required: false,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'cascade',
              configs: this.configs.kelas,
              grid: { cols: 12 },
              labelColor: 'secondary',
            },
          ],
        },
      };

      if (['daring', 'luring'].includes(this.jenis)) {
        let masterDiklat = this.$mapForMaster((this.masters && this.masters.m_diklat_paud) || {}) || [];
        let masterJenjang = this.$mapForMaster((this.masters && this.masters.m_jenjang_diklat_paud) || {}) || [];
        let filtered = [];
        let filterdJenjang = [];

        if (this.jenis === 'daring') {
          filtered = masterDiklat.filter((item) => item.value < 2) || [];
          filterdJenjang = masterJenjang;
        } else {
          filtered = masterDiklat.filter((item) => item.value <= 2) || [];
          if (Number(this.$getDeepObj(this.form, 'k_diklat_paud')) === 2) {
            filterdJenjang = masterJenjang.filter((item) => item.value <= 2) || [];
          } else {
            filterdJenjang = masterJenjang;
          }
        }

        temp.diklat.keterangan_diklat.splice(1, 0, {
          type: 'VSelect',
          name: 'k_diklat_paud',
          label: 'Jenis Diklat',
          hint: 'wajib diisi',
          required: true,
          items: filtered,
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          labelColor: 'secondary',
        });
        temp.diklat.keterangan_diklat.splice(2, 0, {
          type: 'VSelect',
          name: 'k_jenjang_diklat_paud',
          label: 'Jenjang Diklat',
          hint: 'wajib diisi',
          items: filterdJenjang,
          required: true,
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          labelColor: 'secondary',
        });

        if (['luring'].includes(this.jenis)) {
          temp.diklat.keterangan_diklat.pop();
          this.$delete(temp.diklat, 'pendaftaran_peserta');
        } else {
          this.$delete(temp.diklat, 'pelaksanaan_diklat');
        }
      } else {
        this.$delete(temp.diklat, 'pelaksanaan_diklat');
      }

      if (['bcmp'].includes(this.jenis)) {
        temp.diklat = {
          keterangan_diklat: [
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Diklat',
              dense: true,
              hint: 'wajib diisi',
              placeholder: 'Isikan Nama Diklat',
              required: true,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'paud_periode_bcmp_id',
              label: 'Angkatan Bimtek',
              hint: 'wajib dipilih',
              items: [
                { value: 1, text: 'Angkatan 1' },
                { value: 2, text: 'Angkatan 2' },
                { value: 3, text: 'Angkatan 3' },
                { value: 4, text: 'Angkatan 4' },
                { value: 5, text: 'Angkatan 5' },
                { value: 6, text: 'Angkatan 6' },
              ],
              required: true,
              hideDetails: false,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VTextarea',
              name: 'deskripsi',
              label: 'Deskripsi',
              hint: '',
              placeholder: 'Isi Deskripsi',
              required: false,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'cascade',
              configs: this.configs.diklat,
              grid: { cols: 12 },
              labelColor: 'secondary',
            },
          ],
          tanggal_pelaksanaan: [
            {
              type: 'VDatePicker',
              name: 'tgl_mulai',
              label: 'Tanggal Mulai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              min: '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VDatePicker',
              name: 'tgl_selesai',
              label: 'Tanggal Selesai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              min: this.form.tgl_mulai || '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
          ],
        };

        temp.kelas.tambah_kelas.splice(2, 1);
        temp.kelas.tambah_kelas.splice(1, 1);
      }

      if (['refreshment'].includes(this.jenis)) {
        temp.diklat = {
          keterangan_bimtek: [
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Nama Bimtek',
              dense: true,
              hint: 'wajib diisi',
              placeholder: 'Isikan Nama Bimtek',
              required: true,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              grid: { cols: 12, md: 12 },
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'k_kategori_bimtek_paud',
              label: 'Pilihan Jenis Bimtek',
              hint: 'wajib diisi',
              required: true,
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'm_kategori_bimtek_paud') || {}),
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'k_jenjang_diklat_paud',
              label: 'Pilihan Jenjang Bimtek',
              hint: 'wajib diisi',
              required: true,
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'm_jenjang_diklat_paud') || {}),
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'k_moda_paud',
              label: 'Pilihan Moda Bimtek',
              hint: 'wajib diisi',
              required: true,
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'm_moda_paud') || {}),
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'VSelect',
              name: 'k_diklat_bimtek_paud',
              label: 'Kategori bimtek',
              hint: 'wajib diisi',
              required: true,
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'm_diklat_bimtek_paud') || {}),
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'VTextarea',
              name: 'deskripsi',
              label: 'Deskripsi',
              hint: '',
              placeholder: 'Isi Deskripsi',
              required: false,
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              labelColor: 'secondary',
            },
            {
              type: 'cascade',
              configs: this.configs.diklat,
              grid: { cols: 12 },
              labelColor: 'secondary',
            },
          ],
          tanggal_pelaksanaan: [
            {
              type: 'VDatePicker',
              name: 'tgl_mulai',
              label: 'Tanggal Mulai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              min: '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
            {
              type: 'VDatePicker',
              name: 'tgl_selesai',
              label: 'Tanggal Selesai',
              dense: true,
              hint: '',
              placeholder: '',
              required: false,
              hideDetails: false,
              outlined: true,
              singleLine: true,
              min: this.form.tgl_mulai || '2021-01-01',
              grid: { cols: 12, md: 6 },
              labelColor: 'secondary',
            },
          ],
        };
        temp.kelas.tambah_kelas.splice(2, 1);
        temp.kelas.tambah_kelas.splice(1, 1);
        if (Number((this.detail && this.detail.k_moda_paud) || 0) === 2) {
          temp.kelas.tambah_kelas.push({
            type: 'VTextField',
            name: 'url_daring',
            label: 'URL Google Meet ',
            dense: true,
            hint: 'wajib diisi',
            placeholder: 'Isikan URL Google Meet',
            required: true,
            hideDetails: false,
            rules: { required: true, url: true },
            outlined: true,
            singleLine: true,
            grid: { cols: 12, md: 12 },
            labelColor: 'secondary',
          });
        }
      }

      const isReadonlyLuring = this.initValue && this.initValue.is_readonly === 1 && this.jenis === 'luring';

      Object.keys(temp['diklat']).forEach((key) => {
        if (key !== 'pembiayaan_diklat') {
          temp['diklat'][key] = temp['diklat'][key].map((item) => {
            if (item.name !== 'k_pembiayaan_paud') {
              item.disabled = isReadonlyLuring;
              if (item.type === 'cascade' && item.configs) {
                item.configs.disabled = item.configs.selector.map(() => isReadonlyLuring);
              }
            }
            return item;
          });
        }
      });

      if (temp['diklat'].pembiayaan_diklat) {
        temp['diklat'].pembiayaan_diklat = temp['diklat'].pembiayaan_diklat.map((item) => {
          item.disabled = false;
          return item;
        });
      }

      return temp;
    },
  },
  methods: {
    roundDecimal(value) {
      return roundDecimal(value);
    },

    reset() {
      this.form = {};
      if (this.type === 'kelas') {
        this.$set(this.form, 'k_propinsi', this.$getDeepObj(this.detail, 'k_propinsi'));
        this.$set(this.form, 'k_kota', this.$getDeepObj(this.detail, 'k_kota'));
      }
    },

    getValue() {
      return { form: this.form };
    },

    initForm(value) {
      if (value) {
        let formulir = [
          ...(this.schemas.diklat.keterangan_diklat || []),
          ...(this.schemas.diklat.keterangan_bimtek || []),
          ...(this.schemas.diklat.pendaftaran_peserta || []),
          ...(this.schemas.diklat.pelaksanaan_diklat || []),
          ...(this.schemas.diklat.pembiayaan_diklat || []),
          ...(this.schemas.kelas.tambah_kelas || []),
          ...(this.schemas.diklat.tanggal_pelaksanaan || []),
          { name: 'k_propinsi' },
          { name: 'k_kota' },
          { name: 'k_kecamatan' },
          { name: 'k_kelurahan' },
        ];

        if (['refreshment'].includes(this.jenis)) {
          formulir = [...formulir, { name: 'k_jenjang_diklat_paud' }];
        }

        for (const item of formulir) {
          if (item.name) {
            this.$set(this.form, item.name, this.$getDeepObj(value || {}, item.name) || '');
          }
        }
      }
    },

    onDelete(tipe) {
      this.$delete(this.initValue, `${tipe}_file`);
      this.$delete(this.initValue, `${tipe}_url`);
    },
  },

  watch: {
    initValue: 'initForm',
    'form.paud_periode_id': {
      handler(value) {
        if (!value) return;
        this.$set(this.form, 'tgl_daftar_mulai', this.mPeriode[value]['tgl_daftar_mulai']);
        this.$set(this.form, 'tgl_daftar_selesai', this.mPeriode[value]['tgl_daftar_selesai']);
      },
      deep: true,
    },
  },
};
</script>
